import { GetUserRelationshipToOrganizationQuery } from 'generated-graphql/graphql';
import { atom } from 'recoil';
import { sessionStorageEffect } from 'services/storage/sessionStorage';

export type UserOrganizationState = NonNullable<
  GetUserRelationshipToOrganizationQuery['getUserRelationshipToOrganization']
>;

enum StateKey {
  UserOrganizationState = 'UserOrganizationState'
}

export const userOrganizationAtom = atom<UserOrganizationState | null>({
  key: StateKey.UserOrganizationState,
  default: null,
  effects: [sessionStorageEffect(StateKey.UserOrganizationState)]
});
